import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawCvWhiteModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "CV");

		this.name = "cv-white";
		this.icon = svg_cv_white;
		this.svgTextIndex = 2;
	}
}

window.customElements.define("inspx-draw-cv-white-module", DrawCvWhiteModule);

const svg_cv_white = (text) => html`
<svg width="60" height="40" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect id="svg_1" height="39.7782" width="59.53381" y="-0.08832" x="0.09961" stroke="#0c0c0c" fill="#ffffff"/>
  <circle stroke-width="2" stroke="#0f0e0e" id="svg_2" r="19.38981" cy="19.93426" cx="20.58938" fill="#ffffff"/>
  <text font-weight="bold" stroke="#0c0c0c" transform="matrix(1.7041094490789126,0,0,1.5329180932031685,0.4489083986507884,3.5733406044007943) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="19.4874" x="17.54522" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">${text}</text>
 </g>
</svg>`;
